import React from "react";

export type SystemType = "카드" | "뉴딜";

interface SystemSelectorProps {
  value: SystemType;
  onChange: (system: SystemType) => void;
}

export default function SystemSelector({ value, onChange }: SystemSelectorProps) {
  return (
    <fieldset className="border border-gray-200 rounded-lg p-4 md:p-5 bg-white dark:border-gray-800 dark:bg-gray-900">
      <legend className="text-base font-bold text-gray-900 px-1 dark:text-gray-100">
        0. 어느 제도가 궁금하신가요
      </legend>
      <p className="text-sm text-gray-600 mt-1 mb-4 dark:text-gray-400">
        지원 구조와 자격 요건이 완전히 달라 판정 문항이 갈립니다.
      </p>

      <label
        className={`flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-colors mb-3 has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-brand-500 ${
          value === "카드"
            ? "border-brand-600 bg-brand-50 dark:border-brand-500 dark:bg-brand-900/30"
            : "border-gray-200 hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-800"
        }`}
      >
        <input
          type="radio"
          name="제도"
          value="카드"
          checked={value === "카드"}
          onChange={() => onChange("카드")}
          className="mt-1 w-4 h-4 accent-brand-700 cursor-pointer"
        />
        <span className="flex-1">
          <b className="block text-gray-900 text-sm dark:text-gray-200">
            국민내일배움카드 — KDT(K-디지털트레이닝) 등 특화훈련
          </b>
          <i className="block text-gray-600 text-xs not-italic mt-1 dark:text-gray-400">
            국가기간전략산업직종·산업구조변화대응 특화훈련(산대특) 포함. 재직·구직 모두 대상이 될 수 있습니다
          </i>
        </span>
      </label>

      <label
        className={`flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-colors has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-brand-500 ${
          value === "뉴딜"
            ? "border-brand-600 bg-brand-50 dark:border-brand-500 dark:bg-brand-900/30"
            : "border-gray-200 hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-800"
        }`}
      >
        <input
          type="radio"
          name="제도"
          value="뉴딜"
          checked={value === "뉴딜"}
          onChange={() => onChange("뉴딜")}
          className="mt-1 w-4 h-4 accent-brand-700 cursor-pointer"
        />
        <span className="flex-1">
          <b className="block text-gray-900 text-sm dark:text-gray-200">K-뉴딜 아카데미</b>
          <i className="block text-gray-600 text-xs not-italic mt-1 dark:text-gray-400">
            미취업 청년(만 15~34세) 대상. 훈련비 자부담이 없고 참여수당이 나옵니다
          </i>
        </span>
      </label>
    </fieldset>
  );
}